import React, { useEffect, useRef } from 'react';
import { SidebarProps } from 'typings/components/Sidebar';

export const Sidebar: React.FC<SidebarProps> = ({ isOpen, children, sidebarPosition, width, handleClose }) => {
    const blipSidebarRef = useRef<any>(null);
    useEffect(() => {
        const { current } = blipSidebarRef;
        current.addEventListener('bdsToggle', handleClose);
        return () => {
            current.removeEventListener('bdsToggle', handleClose);
        };
    }, [handleClose]);

    return (
        <bds-sidebar
            data-testid="sidebar"
            width={width ?? 400}
            ref={blipSidebarRef}
            is-open={isOpen}
            sidebar-position={sidebarPosition}
            background="surface-1"
        >
            {children}
        </bds-sidebar>
    );
};
